"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MULTI_COLUMNS_TYPES = void 0;
var _react = _interopRequireDefault(require("react"));
var _SubMenuWithMultiColumns = require("./SubMenuWithMultiColumns.style");
var _SubMenuItem = require("../../../../SubMenuItem");
var _Text = _interopRequireDefault(require("../../../../Text/Text.render"));
var _SubMenuWithItems = _interopRequireWildcard(require("../SubMenuWithItems"));
const MULTI_COLUMNS_TYPES = exports.MULTI_COLUMNS_TYPES = {
  'DropDown-HeaderMenus.Main.Analytics': _SubMenuItem.SubMenuItem,
  'DropDown-HeaderMenus.Main.ToolsAndServices': _SubMenuWithItems.SubMenuWithItemsDefault
};
const SubMenuWithMultiColumnsComponent = _ref => {
  let {
    menuItems,
    onNavItemDeselected,
    onNavItemSelected,
    showing,
    walkMeId,
    testId,
    positionToLeft,
    parentId,
    openModal
  } = _ref;
  const Component = MULTI_COLUMNS_TYPES[parentId];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, menuItems.map(_ref2 => {
    let {
      subMenu,
      text
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_SubMenuWithMultiColumns.Container, {
      key: text
    }, /*#__PURE__*/_react.default.createElement(_SubMenuWithMultiColumns.TextWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: "Pills",
      variant: "BoldBlack",
      intlText: text
    })), /*#__PURE__*/_react.default.createElement(_SubMenuWithMultiColumns.List, null, /*#__PURE__*/_react.default.createElement(_SubMenuWithItems.default, {
      menuItems: subMenu,
      onNavItemDeselected: onNavItemDeselected,
      onNavItemSelected: onNavItemSelected,
      showing: showing,
      walkMeId: walkMeId,
      testId: testId,
      positionToLeft: positionToLeft
    }, subMenuProps => /*#__PURE__*/_react.default.createElement(Component, Object.assign({}, subMenuProps, {
      openModal: openModal,
      customItemWidth: true
    })))));
  }));
};
var _default = exports.default = SubMenuWithMultiColumnsComponent;